import { getField } from "vuex-map-fields";

export default {
  getField,

  merchantName(state) {
    let merchantName = state.invoice && state.invoice.paymentCompany;
    if (merchantName !== "-" && merchantName !== "") {
      return merchantName;
    } else return "this Merchant";
  },

  getCardConfig(state) {
    return (cardType) => {
      const cardConfigs = state.merchant.paymentTypes.creditCards.types || [];

      // If cardType is americanexpress, convert it to amex
      if (cardType ?? "") {
        if (cardType.includes("american") && cardType.includes("express")) {
          cardType = "amex";
        }
      }
      return cardConfigs.find((item) => item.cardType === cardType);
    };
  },

  currentCardChargeConfig(state, getters) {
    const selectedPaymentMethod = getters.selectedPaymentMethod;

    if (selectedPaymentMethod && selectedPaymentMethod.isCreditCard) {
      return getters.getCardConfig(selectedPaymentMethod.cardType);
    }
    return null;
  },

  currentSurchargePercentage(state, getters) {
    if (getters.currentCardChargeConfig && !state.merchant.overrideSurcharge) {
      return getters.currentCardChargeConfig.surcharge * 100;
    }
    return 0;
  },

  currentTransactionFee(state, getters) {
    if (getters.currentCardChargeConfig && !state.merchant.overrideSurcharge) {
      return getters.currentCardChargeConfig.transactionCharge;
    }
    return 0;
  },

  totalSurcharge(state, getters) {
    if (state.payingToday > 0 && !state.merchant.overrideSurcharge) {
      return state.payingToday * (getters.currentSurchargePercentage / 100) + getters.currentTransactionFee;
    }
    return 0;
  },

  invoiceAmountDue: (state) => {
    let total = state.invoice.amountDue;
    let locale = state.merchant.locale;
    let currencySymbol = state.merchant.currency;
    let formatter = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currencySymbol,
    });

    return formatter.format(total);
  },

  scheduledPaymentDate: (state) => {
    if (state.scheduledPaymentDate.length > 0) {
      const d = Date.parse(state.scheduledPaymentDate);
      const _date = new Date(d);
      return _date.toDateString();
    } else return "-";
  },

  creditCards: (state) => {
    return state.payer.paymentMethods.filter((paymentMethod) => paymentMethod.isCreditCard) || [];
  },

  bankDebits: (state) => {
    return state.payer.paymentMethods.filter((paymentMethod) => paymentMethod.isBankDebit) || [];
  },

  selectedPaymentMethod: (state) => {
    return state.payer.paymentMethods[state.selectedPaymentMethodIndex];
  },

  isAVSValidationIncluded: (state) => {
    let isUserAPayer = state.user.isLoggedIn;
    return state.merchant.isAvsEnabled && isUserAPayer;
  },

  isAVSFromSelectedPaymentMethodCompleted: (state, getters) => {
    let isCompleted = false;
    let creditCard = getters.selectedPaymentMethod;

    if (state.merchant.isAvsEnabled && creditCard) {
      isCompleted = !!(
        creditCard.billingDetails.country &&
        creditCard.billingDetails.state &&
        creditCard.billingDetails.suburb &&
        creditCard.billingDetails.postcode &&
        creditCard.billingDetails.streetAddress
      );
    }

    return isCompleted;
  },

  getTermsByNames: (state) => (termNames) => {
    return state.termsAndConditions.terms.filter((term) => termNames.includes(term.name));
  },

  isMerchantFlow: (state) => {
    return state.user.isAdminRole || state.isVirtualTerminal;
  },

  isCreditCardAccepted: (state) => state.merchant.paymentTypes.creditCards.maxLimit > 0,
  isBankDebitAccepted: (state) => state.merchant.paymentTypes.bankDebit.maxLimit > 0,

  isPaymentMethodAccepted: (state, getters) => (paymentMethod) => {
    const isCardTypeAccepted = !!getters.getCardConfig(paymentMethod.cardType);
    return (
      (paymentMethod.isCreditCard && getters.isCreditCardAccepted && isCardTypeAccepted) ||
      (paymentMethod.isBankDebit && getters.isBankDebitAccepted)
    );
  },

  isThirdPartyIntegrationPresent: (state) => {
    let isPresent = false;

    // Checks if the `thirdPartyIntegration` property is present in the `state` and is a valid object
    if (
      state.thirdPartyIntegration !== undefined &&
      state.thirdPartyIntegration !== null &&
      typeof state.thirdPartyIntegration === "object"
    ) {
      isPresent = true;
    }

    return isPresent;
  },

  isThirdPartyIntegrationReturnUrlPresent: (state, getters) => {
    let isPresent = false;

    if (getters.isThirdPartyIntegrationPresent) {
      if ("returnUrl" in state.thirdPartyIntegration && state.thirdPartyIntegration.returnUrl) {
        isPresent = true;
      }
    }

    return isPresent;
  },

  isPSAMerchant: (state) => {
    return state.merchant.merchantAccountingPackage.toLowerCase() == "connectwise";
  },
};
